import axiosInstant from "../../axiosInstant";


export async function registerUser(userData) {
    try {
      console.log("userData ", userData);
      const response = await axiosInstant.post('user/register', userData);
      console.log("registerUser response:", response);
      return response.data;
    } catch (error) {
      console.error("registerUser error:", error);
  
      // Check if error.response exists (i.e., the server responded with an error status)
      if (error.response && error.response.data) {
        return {
          success: false,
          errors: error.response.data.errors || null,
          msg: error.response.data.msg || error.response.data.errors,
        };
      }
  
      // Handle network errors or unexpected errors
      return {
        success: false,
        msg: "An unexpected error occurred. Please try again later.",
      };
    }
  }

//   // Assuming AddNewAccount is your backend API call
// }


export async function checkEmail_and_Phone_Exists({
    email,
    phone,
  }) {

    const response = await axiosInstant
      .post(
        `user/check-availability`,{
            email,
            phone,
          }
      )
      .then((res) => {
        console.log("registerUser ",res)
        return res.data;
      })
      .catch((error) => {
    
        return error.response.data;
      });
    return response;
  }